export default () => {
    const colors = ['blue', 'pink', 'green', 'yellow'];

    const color = colors[Math.floor(Math.random() * colors.length)];

    return `icon_link_${color}.svg`;
};
